import { ArrowRight } from "lucide-react";
import { MaskedLine, FadeUp, Overline } from "../components/Reveal";
import { useEnquiry } from "../context/EnquiryContext";
import { IMAGES, INDUSTRIES } from "../data/content";

const INDUSTRY_IMAGES = [IMAGES.fittings, IMAGES.texture, IMAGES.tools, IMAGES.hero, IMAGES.fittings];

export default function Industries() {
  const { openEnquiry } = useEnquiry();

  return (
    <main data-testid="industries-page">
      <section className="pt-32 sm:pt-44 pb-14 sm:pb-20 px-5 sm:px-8 lg:px-12 border-b border-ink/15">
        <FadeUp immediate y={12}>
          <Overline className="mb-8">Industries &amp; Customers</Overline>
        </FadeUp>
        <h1 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-[13vw] sm:text-8xl">
          <MaskedLine immediate delay={0.15}>Who We</MaskedLine>
          <MaskedLine immediate delay={0.3}>Serve</MaskedLine>
        </h1>
        <FadeUp immediate delay={0.45} className="mt-8 max-w-xl">
          <p className="text-base sm:text-lg text-ink/65 leading-relaxed">
            Dependable hardware and industrial supply for purchase heads, project teams,
            maintenance departments and the professionals who keep industry moving.
          </p>
        </FadeUp>
      </section>

      <section className="border-b border-ink/15">
        {INDUSTRIES.map((ind, i) => (
          <div
            key={ind.id}
            data-testid={`industry-${ind.id}`}
            className="grid grid-cols-1 lg:grid-cols-12 border-b border-ink/15 last:border-b-0"
          >
            <div className="lg:col-span-7 px-5 sm:px-8 lg:px-12 py-14 sm:py-20 flex flex-col justify-center">
              <FadeUp>
                <p className="font-mono text-xs text-ink/40 mb-6">{ind.id}</p>
                <h2 className="font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-5xl lg:text-6xl">
                  {ind.title}
                </h2>
                <p className="mt-6 text-base sm:text-lg text-ink/65 leading-relaxed max-w-lg">
                  {ind.desc}
                </p>
                <button
                  data-testid={`industry-enquire-${ind.id}`}
                  onClick={() => openEnquiry("")}
                  className="mt-8 inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase link-underline self-start"
                >
                  Discuss Your Requirement <ArrowRight size={14} />
                </button>
              </FadeUp>
            </div>
            <div className="lg:col-span-5 border-t lg:border-t-0 lg:border-l border-ink/15">
              <div className="h-64 lg:h-full min-h-[260px] overflow-hidden">
                <img
                  src={INDUSTRY_IMAGES[i]}
                  alt={ind.title}
                  className="h-full w-full object-cover grayscale contrast-125 hover:scale-[1.03] transition-transform duration-[1.2s] ease-out"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="bg-accent text-ink px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-8">
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.92] text-3xl sm:text-5xl max-w-2xl">
            Purchase heads &amp; project teams — send your BOM.
          </h2>
          <button
            data-testid="industries-bottom-cta"
            onClick={() => openEnquiry("")}
            className="inline-flex items-center gap-2 bg-ink text-paper font-mono text-xs tracking-[0.2em] uppercase px-8 py-5 hover:bg-paper hover:text-ink transition-colors self-start"
          >
            Send Your Requirement <ArrowRight size={14} />
          </button>
        </div>
      </section>
    </main>
  );
}
